import FundAllocation from "../fundAllocation";
import fundInfo from "../funds";

export default class FundAllocationCalculation {
    public allocations: Array<FundAllocation>;
    public lumpSumAmount: number;
    public trusteeBankAccount: FundAllocation;
    public moneyFund: FundAllocation;
    public matchingIncomeFund: FundAllocation;
    public responsibleGrowthFund: FundAllocation;

    constructor(allocations: Array<FundAllocation>, lumpSumAmount: number) {
        this.allocations = allocations;
        this.lumpSumAmount = lumpSumAmount;
        this.trusteeBankAccount = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.trusteeBankAccount.id);
        this.moneyFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.moneyFund.id);
        this.matchingIncomeFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.matchingIncomeFund.id);
        this.responsibleGrowthFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.responsibleGrowthFund.id);
    }

    private static getAllocationByFundId(allocations: Array<FundAllocation>, fundId: number): FundAllocation {
        return allocations.filter(a => a.fund.id == fundId)[0];
    }
}
